<template>
  <div>
    <router-view></router-view>
    <!-- <div class="tabheight"></div> -->
    <van-tabbar
      v-if="
        !$route.meta.hideTabbar &&
        ((this.$route.path !== '/pc' && this.$route.path !== '/') ||
          (this.$route.path === '/' && this.$device.isMobile))
      "
      route
      active-color="#4286F5"
      inactive-color="#3D3D3D"
      v-model="active"
      @change="onChange"
    >
      <div class="tabbar-surface" aria-hidden="true"></div>
      <div class="tabbar-gradient-shadow" aria-hidden="true"></div>
      <div class="tabbars_list">
        <template v-for="(item, index) in navList">
          <template v-if="index !== 2">
            <van-tabbar-item
              v-if="item.url"
              :name="item.url"
              :key="index"
            >
              <span>{{ displayNavTitle(item) }}</span>
              <template #icon="props">
                <van-image
                  width="28px"
                  height="28px"
                  :src="active == item.url ? item.active : item.inactive"
                />
              </template>
            </van-tabbar-item>
          </template>
          <template v-else>
            <div :key="index" class="tabbar-center-item flexc al_center flex1">
              <div class="button_push" @click="onJump(item)">
                <img :src="item.inactive" class="logo_push" />
              </div>
              <div class="tabbar-special-label">
                {{ displayNavTitle(item) }}
              </div>
            </div>
          </template>
        </template>
      </div>
      <!--      <van-tabbar-item to="/sw" icon="service-o">商务</van-tabbar-item>-->
      <!--      <van-tabbar-item to="/cart" icon="shopping-cart-o">交易</van-tabbar-item>-->
      <!--      <van-tabbar-item to="/cart" icon="shopping-cart-o">购物车</van-tabbar-item>-->
    </van-tabbar>
  </div>
</template>

<script>
import { getBannerAdv } from "@/api/home";
import { mapState } from "vuex";
import { navigationMessageKey } from "@/i18n/catalog";
export default {
  name: "layoutIndex",
  data() {
    return {
      active: "",
      navList: [], //处理数据结构的底部导航栏数据
    };
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler(path) {
        // 父布局不会在子路由切换时重建，底栏选中态需要主动跟随当前路由。
        this.syncActiveRoute(path);
      },
    },
    navList() {
      // 导航配置异步返回后，再按实际的首页 URL 校准一次。
      this.syncActiveRoute(this.$route.path);
    },
  },
  created() {
    this.queryBannerAdv(
      { which: 2, type: 5, position: "LAYOUT", status: 0 },
      (res) => {
        if (res.code == 200 && res.data && res.data.length > 0) {
          // 对数组进行排序，按照sort字段从小到大排列且过滤出status为0的项
          const data = res.data
            .sort((a, b) => a.sort - b.sort)
            .filter((item) => item.status == 0);
          // 创建新数组
          const newList = [];
          // 遍历剩余项，每两个合并成一个
          for (let i = 0; i < data.length; i += 2) {
            // 获取当前项
            const firstItem = data[i];
            // 获取下一项（可能不存在）
            const secondItem = data[i + 1];
            // 如果有下一项，则合并
            if (secondItem) {
              // 创建合并对象，以第一项为基础
              const mergedItem = {
                ...firstItem,
                // 重命名第一个对象的image为inactive
                inactive: firstItem.image,
                // 第二个对象的image作为active
                active: secondItem.image,
                // 移除原来的image属性
                image: undefined,
              };
              newList.push(mergedItem);
            } else {
              // 如果没有下一项，直接添加当前项（处理奇数情况）
              newList.push({
                ...firstItem,
                inactive: firstItem.image,
                active: null, // 没有第二项时active为null
                image: undefined,
              });
              this.navList = newList.slice(0, -1);
              const lastOne = newList[newList.length - 1];
              // 在索引2的位置插入（即第三项）
              this.navList.splice(2, 0, lastOne);
            }
          }
        }
      }
    );
  },

  methods: {
    displayNavTitle(item) {
      const key = navigationMessageKey(item?.url, item?.title || item?.text);
      // 动态简中示例：按 navigationMessageKey 的路由／标题映射取词；未知导航保留原名；完整中文见对应 zh-CN.js，示例不代表固定返回值
      // nav.home：首页
      // nav.publish：发布
      // nav.featured：精选
      // nav.bidding：竞标
      // nav.supply：供需
      // nav.wiki：百科
      return key ? this.$t(key) : item?.title || "";
    },
    syncActiveRoute(path) {
      const isHomeRoute = path === "/" || path === "/home";
      const homeItem = isHomeRoute
        ? this.navList.find(
            (item) =>
              item.url === "/" ||
              item.url === "/home" ||
              item.title === "首页" ||
              item.text === "首页"
          )
        : null;

      this.active = homeItem?.url || (isHomeRoute ? "/home" : path);
    },
    // 切换tabbar
    onChange(name) {
      this.active = name;
      const item = this.navList.find((item) => item.url == name);
      this.onJump(item);
    },
    queryBannerAdv(params, callback) {
      getBannerAdv(params)
        .then((resp) => {
          callback(resp);
        })
        .catch((error) => {
          console.error("请求图片资源失败:", error);
        });
    },
    onJump(item) {
      if (item && item.url) {
        this.$router.push(item.url);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.van-tabbar {
  // 仅在存在底部安全区的设备上整体下移，普通设备保持原位置。
  --tabbar-position-offset: min(10px, env(safe-area-inset-bottom, 0px));
  display: flex;
  justify-content: space-between;
  max-width: @max-width;
  align-items: center;
  margin: 0 auto;
  overflow: visible;
  isolation: isolate;
  background: transparent;
  border-top: 0;
  box-shadow: none;

  &::after {
    border-color: transparent;
  }
}

.tabbar-surface {
  position: absolute;
  top: -24px;
  right: 0;
  left: 0;
  z-index: 0;
  display: block;
  width: 100%;
  height: calc(89px + constant(safe-area-inset-bottom));
  height: calc(89px + env(safe-area-inset-bottom, 0px));
  overflow: visible;
  background: rgba(255, 255, 255, 0.85);
  filter: drop-shadow(0 -4px 18px rgba(30, 56, 96, 0.08));
  // 原始 SVG 曲线与下方矩形共同组成一张遮罩，整块玻璃只合成一次。
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%201%201'%20preserveAspectRatio='none'%3E%3Cpath%20fill='white'%20d='M0%20.269663H.371795C.417949%20.269663%20.448718%20.033708%20.5%20.033708C.551282%20.033708%20.582051%20.269663%20.628205%20.269663H1V1H0Z'/%3E%3C/svg%3E"),
    linear-gradient(#000 0 0);
  -webkit-mask-position: 0 0, 0 24px;
  -webkit-mask-size: 100% 89px, 100% calc(100% - 24px);
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-composite: source-over;
  mask-image: url("data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%201%201'%20preserveAspectRatio='none'%3E%3Cpath%20fill='white'%20d='M0%20.269663H.371795C.417949%20.269663%20.448718%20.033708%20.5%20.033708C.551282%20.033708%20.582051%20.269663%20.628205%20.269663H1V1H0Z'/%3E%3C/svg%3E"),
    linear-gradient(#000 0 0);
  mask-position: 0 0, 0 24px;
  mask-size: 100% 89px, 100% calc(100% - 24px);
  mask-repeat: no-repeat;
  mask-composite: add;
  -webkit-backdrop-filter: blur(24px) saturate(150%);
  backdrop-filter: blur(24px) saturate(150%);
  pointer-events: none;
  transform: translateY(var(--tabbar-position-offset));
}

.tabbar-gradient-shadow {
  position: absolute;
  right: 0;
  bottom: -4px;
  left: 0;
  z-index: 1;
  height: 56px;
  background: linear-gradient(
    90deg,
    rgba(147, 95, 237, 0.25) 0%,
    rgba(93, 157, 253, 0.25) 100%
  );
  border-radius: 50% 50% 0 0;
  filter: blur(20px);
  -webkit-mask-image: linear-gradient(
    to top,
    #000000 0%,
    rgba(0, 0, 0, 0.72) 42%,
    transparent 100%
  );
  mask-image: linear-gradient(
    to top,
    #000000 0%,
    rgba(0, 0, 0, 0.72) 42%,
    transparent 100%
  );
  pointer-events: none;
  transform: translateY(var(--tabbar-position-offset));
}

.tabbars_list {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  height: 100%;
  background: transparent;
  transform: translateY(var(--tabbar-position-offset));
}

.tabbar-center-item {
  position: relative;
  z-index: 1;
  isolation: isolate;
}

.button_push {
  position: relative;
  top: 3px;
  z-index: 2;
  width: 52px;
  height: 52px;
  padding: 5px;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(30, 56, 96, 0.14),
    0 0 0 1px rgba(66, 134, 245, 0.04);
}

.logo_push {
  z-index: 999;
  width: 42px !important;
  height: 42px !important;
}

.van-tabbar-item {
  font-size: 12px !important;
  line-height: 16px !important;
  background: transparent;

  ::v-deep .van-tabbar-item__icon {
    margin-bottom: 2px !important;
  }

  ::v-deep .van-tabbar-item__text {
    color: #69717d !important;
    line-height: 16px !important;
  }
}

.tabbar-special-label {
  position: relative;
  top: 4px;
  margin-top: 0;
  color: #69717d;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}

.active {
  color: #4286f5 !important;
}
</style>
